var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NcButton,{directives:[{name:"show",rawName:"v-show",value:(_setup.isVisible),expression:"isVisible"}],on:{"click":_setup.onClick}},[_vm._v("\n\t"+_vm._s(_setup.t('files', 'Search everywhere'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }